// extracted by mini-css-extract-plugin
export default {"modal__footer":"style_modal__footer__EI0Ln","modal__footer__button_next":"style_modal__footer__button_next__febm4","hidden":"style_hidden__LYuOj"};